import { all, fork, put, takeEvery, takeLatest } from "redux-saga/effects";
import { isEmpty } from "ramda";
import { UserGroupActionTypes } from "./types";
import { fetch, save, drop } from "../../repo/usergroup";
import {
  fetchRequest,
  fetchError,
  fetchSuccess,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
} from "./actions";
import { isAuthError } from "../";
import { dirty } from "../session/actions";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const group = yield fetch(action.payload.id, action.payload.params);
    if (group.errors && !isEmpty(group.errors)) {
      if (isAuthError(group.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(group.errors)));
    } else {
      yield put(fetchSuccess(group));
    }
    yield put(fetchSuccess(group));
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(UserGroupActionTypes.FETCH, handleFetch);
}

function* handleSave(action: ReturnType<typeof saveRequest>) {
  try {
    const group = yield save(action.payload.data);
    // we may still have an error
    // if so then we should yield error
    if (group.errors && !isEmpty(group.errors)) {
      if (isAuthError(group.errors)) {
        yield put(dirty());
      }
      yield put(saveError(JSON.stringify(group.errors)));
      action.payload.callback &&
        action.payload.callback(JSON.stringify(group.errors), null);
    } else {
      yield put(saveSuccess(group));
      action.payload.callback && action.payload.callback(null, group);
    }
  } catch (err) {
    yield put(saveError(err));
    action.payload.callback &&
      action.payload.callback(
        "An error occurred while saving User Group",
        null
      );
  }
}

function* watchSaveRequest() {
  yield takeEvery(UserGroupActionTypes.SAVE_REQUEST, handleSave);
}

function* handleDelete(action: ReturnType<typeof deleteRequest>) {
  try {
    const dropResponse = yield drop(action.payload.id);
    if (dropResponse.errors && !isEmpty(dropResponse.errors)) {
      if (isAuthError(dropResponse.errors)) {
        yield put(dirty());
      }
      yield put(deleteError(JSON.stringify(dropResponse.errors)));
      action.payload.callback && action.payload.callback(dropResponse.errors);
    } else {
      yield put(deleteSuccess());
      action.payload.callback && action.payload.callback(null);
      yield put(fetchRequest(null));
    }
  } catch (err) {
    yield put(deleteError(err));
    action.payload.callback && action.payload.callback(err);
  }
}

function* watchDeleteRequest() {
  yield takeLatest(UserGroupActionTypes.DELETE_REQUEST, handleDelete);
}
export default function* userGroupSaga() {
  yield all([
    fork(watchFetchRequest),
    fork(watchSaveRequest),
    fork(watchDeleteRequest),
  ]);
}
